import FSUserList   from '../FSUserList.vue'
import FSUserDetail from '../FSUserDetail.vue'

export default [
    {
        path: '/admin_fs_users',
        name: '/admin_fs_users',
        component: FSUserList,
        meta: { layout: 'admin-layout' },
    },
    {
        path: '/admin_fs_user/:id',
        name: '/admin_fs_user',
        component: FSUserDetail,
        meta: { layout: 'admin-layout' },
    },
]
